import { routePaths } from "@/shared/config/routePaths";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import('./HomePage').then(m => ({ default: m.HomePage })));

export const homeRouter: RouteObject = {
    index: true,
    path: routePaths.home,
    element: <HomePage />
}

